<section class="not-found-page">
  <p class="code">404</p>
  <h2>Page introuvable</h2>
  <p>L'URL demandée ne correspond à aucune page disponible sur l'intranet.</p>
  <button type="button" (click)="goHome()">Retour à l'accueil intranet</button>
</section>